// extracted by mini-css-extract-plugin
export default {"userItemsContainer":"myMessages_userItemsContainer__h6k2+"};